module.exports = __webpack_public_path__ + "img/profile.a262db24.svg";